<template>
<div class="OrderTable">
    <div class="handle_select_box">
        <div class="handle_left_box">
            <el-button @click="exportBtn">导出EXCEL</el-button>
        </div>
        <div class="handle_right_box">
            <div>
                <el-input @focus="closeDetalisInfo" v-model="paramsInfo.customername" placeholder="订购人昵称"></el-input>
            </div>
            <div>
                <el-input @focus="closeDetalisInfo" v-model="paramsInfo.orderno" placeholder="订单号"></el-input>
            </div>
            <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
        </div>
    </div>
    <div class="table_box">
        <el-table @cell-click="tableCellClick" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%">
            <el-table-column label="购票用户头像/昵称" min-width="200">
                <template slot-scope="scope">
                    <div class="user_info_box">
                        <!-- <img :src="require('@/common/images/communityPurchases/logo.png')" alt=""> -->
                        <img :src="scope.row.customericonurl" alt="">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="orderno" label="订单号" align="center" min-width="180"></el-table-column>
            <el-table-column prop="datetime" label="订单时间" align="center" min-width="180"></el-table-column>
            <el-table-column prop="ticketname" label="票种" align="center" min-width="150"></el-table-column>
            <el-table-column prop="totalticketcount" label="票种张数" align="center"></el-table-column>
            <el-table-column label="价格(元)" align="center">
                <template slot-scope="scope"><span style="color: #FF4747;">{{scope.row.ordermoneyshow}}</span></template>
            </el-table-column>
            <el-table-column label="状态" align="center" show-overflow-tooltip>
                <template slot-scope="scope"><span :class="orderStatusClass(scope.row.statustext)">{{scope.row.statustext}}</span></template>
            </el-table-column>
            <el-table-column label="操作" align="right">
                <template slot-scope="scope">
                    <div class="table_handle_box">
                        <span @click="handleBtn(scope.row, 2)" class="cursor_class" v-if="scope.row.status === 1 && !(eventInfoData.eventstatus === 100 || eventInfoData.eventstatus === 30)">通过</span>
                        <span v-if="scope.row.status === 1 && !(eventInfoData.eventstatus === 100 || eventInfoData.eventstatus === 30)">&nbsp;|&nbsp;</span>
                        <span @click="handleBtn(scope.row, 3)" class="cursor_class" v-if="scope.row.status === 1 && !(eventInfoData.eventstatus === 100 || eventInfoData.eventstatus === 30)">拒绝</span>
                        <span @click="cancellationBtn(scope.row)" class="cursor_class" v-if="scope.row.status === 30 && !(eventInfoData.eventstatus === 100 || eventInfoData.eventstatus === 30)">作废</span>
                        <span v-if="!(scope.row.status === 1 || scope.row.status === 30) || (eventInfoData.eventstatus === 100 || eventInfoData.eventstatus === 30)">—</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" ref="page" @getList="searchBtn"></page>
    </div>
    <div class="cancellation_order_pop_box">
        <el-dialog title="作废提示" :visible.sync="showCancellation">
            <div class="tips_content_box">
                <img :src="require('@/common/images/activeOperate/tips.png')" alt="">
                <p :class="orderInfo.tickettype === 2 ? '' : 'p_tips1'">作废后该用户将不可参与本次活动</p>
                <p v-if="orderInfo.tickettype === 2" class="p_tips2">订单取消产生的手续费将由主办方承担</p>
                <div class="cancellation_content_box">
                    <p v-if="orderInfo.tickettype === 2" style="margin-bottom: 10px; color: #999;">账户余额：￥{{eventInfoData.allbalance}}&emsp;&emsp;<label @click="recharge" style="color: #409EFF; cursor: pointer;">去充值></label></p>
                    <p>您本次要作废的订单</p>
                    <p>
                        <span>订单编号：{{orderInfo.orderno}}</span>
                        <span>订单时间：{{orderInfo.datetime}}</span>
                    </p>
                    <p>
                        <span>票种：{{orderInfo.ticketname}}</span>
                        <span>数量：{{orderInfo.totalticketcount}}</span>
                    </p>
                    <p>
                        <!-- <span>价格：<label v-if="orderInfo.uprice !== '免费'">¥</label>{{orderInfo.uprice}}</span> -->
                        <span>价格：<label v-if="orderInfo.tickettype === 2">¥</label>{{orderInfo.uprice}}</span>
                        <!-- <span>数量：{{orderInfo.totalticketcount}}</span> -->
                        <span v-if="orderInfo.tickettype === 2" style="color: #FF4747;">手续费：¥{{orderInfo.paypoundage}}</span>
                    </p>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showCancellation = false">取 消</el-button>
                <el-button type="primary" @click="sureClick()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
    <div class="approval_pop_box">
        <el-dialog title="拒绝提示" :visible.sync="showApproval">
            <div class="tips_content_box">
                <img :src="require('@/common/images/activeOperate/tips.png')" alt="">
                <p>请提交拒绝理由</p>
                <div class="approval_content_box">
                    <p>您本次要拒绝的订单为：</p>
                    <p style="color: #333;">{{orderInfo.orderno}}</p>
                    <p>如果确定要拒绝选中人员，请填写选中详细原因</p>
                    <div style="margin: 18px 0;"></div>
                    <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 6}" placeholder="请输入拒绝理由" v-model="objection"></el-input>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showApproval = false">取 消</el-button>
                <el-button type="danger" @click="sureApproval()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
    <div class="right_details_box bgc box-shadow" :class="showHelp ? 'show_helps_box' : 'hide_icon_box'" ref="helps">
        <div v-if="showHelp" class="show_helps show_icon" @click="showHelp = false"></div>
        <div class="title_box">
            <span>报名资料</span>
            <img @click="showHelp = false" :src="require('@/common/images/activeOperate/close_icon.png')" alt="">
        </div>
        <div class="details_info_box">
            <div class="box1">
                <img :src="listDetailsInfo.customericonurl" alt="">
                <div>
                    <p>{{listDetailsInfo.customername}}</p>
                    <p>票种：{{listDetailsInfo.ticketname}}</p>
                    <p>票种张数：{{listDetailsInfo.itemcount}}</p>
                </div>
            </div>
            <div class="box2">
                <p class="ptitle">详细信息</p>
                <div v-for="(item, index) in listDetailsInfo.ownercustomerinfo" :key="index">
                    <p v-if="listDetailsStatus === 30"><span>票号</span><span>{{item.ticketno}}</span></p>
                    <p><span>姓名</span><span>{{item.joinername}}</span></p>
                    <p><span>手机</span><span>{{item.joinermobile}}</span></p>
                    <p v-for="(subItem, i) in item.collistvalue" :key="i"><span>{{subItem.name}}</span><span>{{subItem.value}}</span></p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {getEenrolleventOrderList, exportOrderList, getEventOrderDetail, updateEventorderStatus, updateCancelledEventorder} from 'api/activeApi'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'OrderTable',
    props: ['eventListData', 'activeStatus', 'eventInfoData'],
    data() {
        return {
            showCancellation: false,
            showApprovalStatus: '',
            showApproval: false,
            total: 0,
            tableData: [],
            paramsInfo: {
                orderno: '', // 订单号
                customername: '' // 订购人昵称
            },
            showHelp: false,
            oldOrderinnerid: '',
            newOrderinnerid: '',
            listDetailsStatus: '',
            listDetailsInfo: {},
            orderInfo: {},
            objection: '' // 拒绝理由
        }
    },
    mounted() {},
    methods: {
        // 去充值
        recharge() {
            let newurl = this.$router.resolve({
                name: 'Balance'
            })
            window.open(newurl.href, '_blank')
        },
        // 作废按钮
        cancellationBtn(val) {
            this.orderInfo = val
            this.showCancellation = true
            // console.log(this.orderInfo)
            // console.log(val)
            // this.closeDetalisInfo()
        },
        // 确认作废按钮
        sureClick() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                orderno: this.orderInfo.orderno,
                status: 100
            }
            updateCancelledEventorder({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.showCancellation = false
                    this.$message.success(`操作成功！`)
                    this.$emit('findStatisticalUserNum')
                    this.searchBtn()
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        // 通过、拒绝按钮
        handleBtn(val, val2) {
            this.orderInfo = val
            this.showApprovalStatus = val2
            if (val2 === 2) {
                this.sureApproval()
            } else if(val2 === 3) {
                this.showApproval = true
            }
            // console.log(val)
        },
        // 确认通过、拒绝
        sureApproval() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                orderno: this.orderInfo.orderno,
                status: this.showApprovalStatus,
                authmemo: this.objection
            }
            updateEventorderStatus({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.closeDetalisInfo()
                    this.showApproval = false
                    this.$message.success(`操作成功！`)
                    this.$emit('findStatisticalUserNum')
                    this.searchBtn()
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        closeDetalisInfo() {
            this.showHelp = false
        },
        tableCellClick(row, column, cell, event) {
            // console.log(row);
            if (column.label === '操作') {
                // 不做处理
            } else {
                this.oldOrderinnerid = this.newOrderinnerid
                this.newOrderinnerid = row.orderno
                if (this.oldOrderinnerid === this.newOrderinnerid) {
                    this.showHelp = !this.showHelp
                } else {
                    this.listDetailsStatus = row.status
                    this.showHelp = false
                    this.findEventUserInfoDetail(row)
                }
            }
        },
        // 查询订单详情
        findEventUserInfoDetail(val) {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                orderno: val.orderno
            }
            getEventOrderDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.listDetailsInfo = data.data
                    this.showHelp = true
                    // setTimeout(() => {
                    //     this.showHelp = true
                    // },50 )
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 分页及搜索
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        // 搜索按钮
        searchBtn() {
            // this.$message.success(`第${this.page.page}页`)
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                eventstatus: this.activeStatus
            }
            getEenrolleventOrderList({
                data: Object.assign({}, params, this.paramsInfo, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.closeDetalisInfo()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 导出按钮
        exportBtn() {
            this.closeDetalisInfo()
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                eventstatus: this.activeStatus
            }
            exportOrderList({
                data: Object.assign({}, params, this.paramsInfo),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '订单管理' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        orderStatusClass(val) {
            if(val === '待审核' || val === '待支付') {
                return 'yellow_text'
            } else if(val === '报名成功') {
                return 'green_text'
            } else {
                return 'gray_text'
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        eventListData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                // console.log('this.eventListData:', this.eventListData)
                this.showHelp = false
                this.tableData = this.eventListData.content
                this.total = 0
                this.paramsInfo.orderno = ''
                this.paramsInfo.customername = ''
                setTimeout(() => {
                    this.total = this.eventListData.pageinfo.rowCount
                }, 20)
            })
        }
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss">
.OrderTable {
    padding: 0 20px;
    .handle_select_box {
        display: flex;
        justify-content: space-between;
        .handle_right_box {
            display: flex;
            &>div {
                width: 150px;
                margin-right: 30px;
            }
        }
    }
    .table_box {
        background-color: #fff;
        margin-top: 30px;
        padding-bottom: 20px;
        .el-table th>.cell {
            font-weight: bold!important;
        }
        .el-table__empty-block {
            min-height: 360px;
        }
        .el-table__empty-text {
            box-sizing: border-box;
            line-height: 0px;
            padding-top: 150px;
        }
        .el-table__row {
            cursor: pointer;
        }
        .el-table_1_column_8 {
            cursor: text;
        }
        .user_info_box {
            display: flex;
            align-items: center;
            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
            span {
                color: #409EFF;
            }
        }
        .table_handle_box {
            span {
                color: #439FFE;
            }
            .cursor_class{
                cursor: pointer;
            }
        }
        .green_text {
            color: #0ABF53;
        }
        .yellow_text {
            color: #FFA904;
        }
        .gray_text {
            color: #909399;
        }
    }
}
</style>